import React, { Component } from 'react'
import backendHost from './config'
import { auth } from './firebase'
// import './App.css'
// import './activation.css'
import './styles/margin.css'


import axios from 'axios'
import {firebase_url} from './config'
import SetPasswordForm from './set-password-form'


class Activation extends Component {
  state = {
    loading: true,
    errorMessage: '',
    errorCode: '',
    user: null,
    userHandler: null,
    ptin: '',
    validationError: '',
    password: '',
    password_2: '',
    page: 'vanilla',
    authLoader: false
  };
  handleToken = token => {
    let userHandler = auth.onAuthStateChanged(user => {
      if(user) {
        this.setState({loading: false, authLoader: false})
      }
    });
    this.setState({userHandler: userHandler});
    auth.signInWithCustomToken(token).catch(error => {
      this.setState({errorMessage: error.message, errorCode: error.code, loading: false, authLoader: false})
    })
  };
  componentWillMount = () => {
    const { location } = this.props;
    const queryString = require('query-string');
    const qs = queryString.parse(location.search);
		if ('page' in qs && qs['page'] === 'courses') {
      this.setState({page: 'courses'})
		}
    if ('errorCode' in qs && 'errorMessage' in qs) {
      let ec = decodeURI(atob(qs.errorCode));
      let em = decodeURI(atob(qs.errorMessage));
      this.setState({errorMessage: em, errorCode: ec, loading: false, authLoader: false,})
    }
    if ('activation_code' in qs) {
      this.setState({authLoader: true})
      axios.get(`${firebase_url}/activation?activation_token=${atob(qs.activation_code)}`)
      .then(res => {
        if ('customToken' in res.data) {
          this.handleToken(res.data.customToken)
        }
      }).catch(error => {
        const res = error.response;
        if ('errorMessage' in res.data) {
          this.setState({
            errorMessage: res.data.errorMessage,
            errorCode: res.data.errorCode,
            loading: false,
						authLoader: false,
          })
          }
        })
    }
    if ('token' in qs) {
      this.handleToken(qs.token)
    }
  };
  componentWillUnmount = () => {
    if (this.state.userHandler) {
      this.state.userHandler()
    }
  };
  validatePTIN = (ptin) => {
    return ptin.match(/^[P|p][0-9]{8}$/);
  };

  /**
   * Handles the <SetPasswordForm /> submit after
   * it's validated
   */
  handleSetPasswordFormSubmit = (evt) => {
    let user = auth.currentUser;
    if (user) {
      user.updatePassword(this.state.password)
        .then(() => {
          window.location = backendHost + '/login?page=' + this.state.page
        }).catch(error => {
          this.setState({ errorMessage: error.message, errorCode: error.code })
        })
    }
  }

  render() {
		if (this.state.authLoader) {
			return (<div className="loginBox">
				<p className="subtitle subtitle-loading">Loading.</p>
			</div>
    )}
    if (this.state.loading) {
      return <div className="large-loader" />
    } else if (this.state.errorMessage !== '') {
      return (
        <div>
          <div className="action-row">
            <div className="error-activation">{this.state.errorMessage}</div>
          </div>
          <div className="action-row activation-text">
            <a onClick={evt => {evt.preventDefault(); this.setState({errorMessage: ''}); window.location = backendHost+'/login'}}>Go back</a>
          </div>
        </div>
      )
    } else {
      return <div className="activation-modal">
        <h1 className="title">You're all set.</h1>
        <p className="subtitle">Your account is activated. Set a password for your account and dive in, register for a course, and start learning amazing things for free.</p>

        <div>
          <SetPasswordForm
            password={this.state.password}
            password_2={this.state.password_2}
            handlePasswordEdits={evt => this.setState({ password: evt.target.value })}
            handlePassword2Edits={evt => this.setState({ password_2: evt.target.value })}
            handleSubmit={this.handleSetPasswordFormSubmit}
          />
        </div>
      </div>
    }
  }
}

export default Activation



// WEBPACK FOOTER //
// ./src/activation.js